import { render, staticRenderFns } from "./trip_table.vue?vue&type=template&id=607ba72d&scoped=true&"
import script from "./trip_table.vue?vue&type=script&lang=js&"
export * from "./trip_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607ba72d",
  null
  
)

export default component.exports